var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper",class:{ 'nav-open': _vm.$sidebar.showSidebar }},[_c('navbar'),_c('notifications'),_c('side-bar',{scopedSlots:_vm._u([{key:"links",fn:function(props){return [(
          _vm.currentWorkspace &&
          _vm.currentWorkspace.workspace_type != 'Limited Partner' && _vm.currentWorkspace.workspace_type != 'SPV'
        )?_c('sidebar-item',{attrs:{"link":{
          name: 'Dashboard',
          materialClass: 'material-icons-outlined',
          materialIcon: 'dashboard',
          path: ("/" + (_vm.$route.params.account_id) + "/" + (_vm.$route.params.workspace_id) + "/dashboard/overview"),
        }}}):_vm._e(),(
          _vm.currentWorkspace &&
          _vm.currentWorkspace.workspace_type == 'Limited Partner'
        )?_c('sidebar-item',{attrs:{"link":{
          name: 'Dashboard',
          materialClass: 'material-icons-outlined',
          materialIcon: 'dashboard',
          path: ("/" + (_vm.$route.params.account_id) + "/" + (_vm.$route.params.workspace_id) + "/lpDashboard"),
        }}}):_vm._e(),(
          _vm.currentWorkspace &&
          _vm.currentWorkspace.workspace_type == 'SPV'
        )?_c('sidebar-item',{attrs:{"link":{
          name: 'Dashboard',
          materialClass: 'material-icons-outlined',
          materialIcon: 'dashboard',
          path: ("/" + (_vm.$route.params.account_id) + "/" + (_vm.$route.params.workspace_id) + "/spvDashboard"),
        }}}):_vm._e(),(
          _vm.currentWorkspace &&
          _vm.currentWorkspace.workspace_type != 'General Partner' &&
          _vm.showFundTab &&
          _vm.currentWorkspace.workspace_type == 'Limited Partner'
        )?_c('sidebar-item',{attrs:{"link":{
          name: 'Summary',
          materialClass: 'material-icons-outlined',
          materialIcon: 'monetization_on',
          path: ("/" + (_vm.$route.params.account_id) + "/" + (_vm.$route.params.workspace_id) + "/lpSummary"),
        }}}):_vm._e(),(
          _vm.currentWorkspace && _vm.currentWorkspace.workspace_type == 'SPV'
        )?_c('sidebar-item',{attrs:{"link":{
          name: 'Summary',
          materialClass: 'material-icons-outlined',
          materialIcon: 'monetization_on',
          path: ("/" + (_vm.$route.params.account_id) + "/" + (_vm.$route.params.workspace_id) + "/spvsummary"),
        }}}):_vm._e(),(
          _vm.currentWorkspace &&
          _vm.currentWorkspace.workspace_type == 'General Partner' &&
          _vm.showFundTab &&
          _vm.currentWorkspace.workspace_type != 'Limited Partner'
        )?_c('sidebar-item',{attrs:{"link":{
          name: 'Fund',
          materialClass: 'material-icons-outlined',
          materialIcon: 'monetization_on',
          path: ("/" + (_vm.$route.params.account_id) + "/" + (_vm.$route.params.workspace_id) + "/thesis"),
        }}}):_vm._e(),(
          _vm.showDiligenceTab &&
          _vm.currentWorkspace &&
          _vm.currentWorkspace.workspace_type != 'Limited Partner' && _vm.currentWorkspace.workspace_type !='SPV'
        )?_c('sidebar-item',{attrs:{"link":{
          name: 'Diligence',
          materialClass: 'material-icons-outlined',
          materialIcon: 'diligence',
          path: ("/" + (_vm.$route.params.account_id) + "/" + (_vm.$route.params.workspace_id) + "/diligence"),
        }}}):_vm._e(),(_vm.showPortfolioTab && _vm.currentWorkspace.workspace_type !='SPV')?_c('sidebar-item',{attrs:{"link":{
          name: 'Portfolio',
          materialClass: 'material-icons-outlined',
          materialIcon: 'work_outline',
          path: ("/" + (_vm.$route.params.account_id) + "/" + (_vm.$route.params.workspace_id) + "/portfolio"),
        }}}):_vm._e(),(_vm.showTodoTab)?_c('sidebar-item',{attrs:{"link":{
          name: 'To-Do',
          materialClass: 'material-icons-outlined',
          materialIcon: 'assignment_turned_in',
          path: ("/" + (_vm.$route.params.account_id) + "/" + (_vm.$route.params.workspace_id) + "/todos"),
        }}}):_vm._e(),(_vm.showPeopleTab)?_c('sidebar-item',{attrs:{"link":{
          name: 'People',
          materialClass: 'material-icons-outlined',
          materialIcon: 'people_outline',
          path: ("/" + (_vm.$route.params.account_id) + "/" + (_vm.$route.params.workspace_id) + "/people"),
        }}}):_vm._e(),(
          _vm.showRegistrarTab &&
          _vm.currentWorkspace &&
          _vm.currentWorkspace.workspace_type != 'Limited Partner' && _vm.currentWorkspace.workspace_type != 'SPV'
        )?_c('sidebar-item',{attrs:{"link":{
          name: 'Registrar',
          materialClass: 'material-icons-outlined',
          materialIcon: 'list_alt',
          path: ("/" + (_vm.$route.params.account_id) + "/" + (_vm.$route.params.workspace_id) + "/transactions"),
        }}}):_vm._e(),(
          _vm.showDocumentsTab &&
          _vm.currentWorkspace &&
          _vm.currentWorkspace.workspace_type != 'Limited Partner' && _vm.currentWorkspace.workspace_type != 'SPV'
        )?_c('sidebar-item',{attrs:{"link":{
          name: 'Documents',
          materialClass: 'material-icons-outlined',
          materialIcon: 'library_books',
          path: ("/" + (_vm.$route.params.account_id) + "/" + (_vm.$route.params.workspace_id) + "/documents"),
        }}}):_vm._e()]}}])}),_c('div',{staticClass:"main-panel",attrs:{"id":"main-panel"}},[_c('div',{staticStyle:{"background-color":"white"}},[(_vm.infoBoxMessage.show)?_c('infobox',{attrs:{"message":_vm.infoBoxMessage}}):_vm._e()],1),_c('dashboard-content',{nativeOn:{"click":function($event){return _vm.toggleSidebar.apply(null, arguments)}}}),_c('content-footer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }